import { Component, inject } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-modal-video',
  templateUrl: './modal-video.component.html',
})
export class ModalVideoComponent {
  ngbActiveModal = inject(NgbActiveModal);
}
